'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BundleContext = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    padding: 0 15px;\n    text-align: left;\n    margin-top: .98em ;\n  '], ['\n    padding: 0 15px;\n    text-align: left;\n    margin-top: .98em ;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 0 15px;\n    text-align: left;\n    margin-bottom: 30px;\n  '], ['\n    padding: 0 15px;\n    text-align: left;\n    margin-bottom: 30px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    padding: 0 15px;\n  '], ['\n    padding: 0 15px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    flex-basis: 40%;\n  '], ['\n    flex-basis: 40%;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    flex-direction: column;\n  '], ['\n    flex-direction: column;\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    flex-basis: 60%;\n  '], ['\n    flex-basis: 60%;\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    margin-right: 0;\n  '], ['\n    margin-right: 0;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRhumb = require('react-rhumb');

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _stateUtils = require('pricing-pages-unified-ui/utils/stateUtils');

var _MarketingHubBundle = require('./MarketingHubBundle');

var _MarketingHubBundle2 = _interopRequireDefault(_MarketingHubBundle);

var _SalesHubBundle = require('./SalesHubBundle');

var _SalesHubBundle2 = _interopRequireDefault(_SalesHubBundle);

var _ServiceHubBundle = require('./ServiceHubBundle');

var _ServiceHubBundle2 = _interopRequireDefault(_ServiceHubBundle);

var _ShoppingCart = require('./shopping-cart/ShoppingCart');

var _ShoppingCart2 = _interopRequireDefault(_ShoppingCart);

var _AddOns = require('./AddOns');

var _AddOns2 = _interopRequireDefault(_AddOns);

var _Services = require('./Services');

var _Services2 = _interopRequireDefault(_Services);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _utils = require('./utils');

var _CurrencyPicker = require('../common/CurrencyPicker');

var _CurrencyPicker2 = _interopRequireDefault(_CurrencyPicker);

var _FooterMicrocopy = require('../common/FooterMicrocopy');

var _FooterMicrocopy2 = _interopRequireDefault(_FooterMicrocopy);

var _getUsageTracker = require('../../utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _Tracking = require('../../constants/Tracking');

var _CurrencySelectors = require('../../selectors/CurrencySelectors');

var _CountrySelectors = require('../../selectors/CountrySelectors');

var _TabLayout = require('../TabLayout');

var _TabLayout2 = _interopRequireDefault(_TabLayout);

var _DocumentUtils = require('pricing-pages-unified-ui/static/js/utils/DocumentUtils');

var _PageContainer = require('pricing-pages-unified-ui/components/common/PageContainer');

var _PageContainer2 = _interopRequireDefault(_PageContainer);

var _SpinnerLoadWrapper = require('../../components/loading/SpinnerLoadWrapper');

var _SpinnerLoadWrapper2 = _interopRequireDefault(_SpinnerLoadWrapper);

var _PhoneSupport = require('pricing-pages-unified-ui/components/common/PhoneSupport');

var _PhoneSupport2 = _interopRequireDefault(_PhoneSupport);

var _FailedLoadBanner = require('pricing-pages-unified-ui/components/loading/FailedLoadBanner');

var _FailedLoadBanner2 = _interopRequireDefault(_FailedLoadBanner);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BundleContext = exports.BundleContext = _react2.default.createContext(null);

var PageTitle = _styledComponents2.default.div.withConfig({
  displayName: 'BundlePage__PageTitle'
})(['text-align:center;font-size:32px;padding-top:40px;margin-bottom:10px;font-weight:600;line-height:40px;', ''], _responsiveBreakpoints2.default.tabletPortrait(_templateObject));

var SubTitle = _styledComponents2.default.div.withConfig({
  displayName: 'BundlePage__SubTitle'
})(['text-align:center;font-size:16px;margin-bottom:56px;', ''], _responsiveBreakpoints2.default.tabletPortrait(_templateObject2));

var FailedContentContainer = _styledComponents2.default.div.withConfig({
  displayName: 'BundlePage__FailedContentContainer'
})(['max-width:1200px;margin:0 auto;padding:45px 0 0;']);

var ContentContainer = _styledComponents2.default.div.withConfig({
  displayName: 'BundlePage__ContentContainer'
})(['max-width:1200px;margin:0 auto;padding:0 80px;', ';'], _responsiveBreakpoints2.default.tabletPortrait(_templateObject3));

var StickyContainer = _styledComponents2.default.div.withConfig({
  displayName: 'BundlePage__StickyContainer'
})(['position:-webkit-sticky;position:sticky;top:6%;', ';', ';margin-bottom:60px;'], _responsiveBreakpoints2.default.cs(_templateObject4), _responsiveBreakpoints2.default.tabletPortrait(_templateObject5));

var FlexMain = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'BundlePage__FlexMain'
})(['', ';'], _responsiveBreakpoints2.default.tabletPortrait(_templateObject6));

var BundleHubPicker = _styledComponents2.default.div.withConfig({
  displayName: 'BundlePage__BundleHubPicker'
})(['margin-right:40px;max-width:100%;min-width:50%;', ';', ';'], _responsiveBreakpoints2.default.cs(_templateObject7), _responsiveBreakpoints2.default.tabletPortrait(_templateObject8));

var BundlePage = function BundlePage(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      country = _ref.country,
      purchaseMotionRequestStatus = _ref.purchaseMotionRequestStatus;

  var _useMergeState = (0, _stateUtils.useMergeState)(function () {
    return (0, _utils.getInitialBundleState)();
  }),
      _useMergeState2 = _slicedToArray(_useMergeState, 2),
      state = _useMergeState2[0],
      mergeState = _useMergeState2[1];

  var marketingPlanSelected = state.marketingPlanSelected,
      salesPlanSelected = state.salesPlanSelected,
      servicePlanSelected = state.servicePlanSelected,
      marketingUnits = state.marketingUnits,
      salesUnits = state.salesUnits,
      serviceUnits = state.serviceUnits,
      selectedAddOns = state.selectedAddOns,
      selectedServices = state.selectedServices;


  (0, _react.useEffect)(function () {
    var url = (0, _utils.generateBundleUrl)({
      marketingPlanSelected: marketingPlanSelected,
      salesPlanSelected: salesPlanSelected,
      servicePlanSelected: servicePlanSelected,
      marketingUnits: marketingUnits,
      salesUnits: salesUnits,
      serviceUnits: serviceUnits,
      selectedAddOns: selectedAddOns,
      selectedServices: selectedServices
    });
    history.replaceState(history.state, '', url);
  });

  (0, _react.useEffect)(function () {
    (0, _getUsageTracker2.default)().setProperties({
      activeCurrencyCode: activeCurrencyCode,
      countryTerritory: country
    });
    (0, _getUsageTracker2.default)().track('pageView', {
      screen: _Tracking.SCREENS.CREATE_BUNDLE
    });
  }, []);

  return _react2.default.createElement(
    _TabLayout2.default,
    { selectedPrimaryTab: 'bundle' },
    _react2.default.createElement(
      BundleContext.Provider,
      { value: { state: state, mergeState: mergeState } },
      _react2.default.createElement(
        _PageContainer2.default,
        null,
        purchaseMotionRequestStatus === _RequestStatusTypes2.default.FAILED && _react2.default.createElement(
          FailedContentContainer,
          null,
          _react2.default.createElement(_FailedLoadBanner2.default, {
            hasFailed: purchaseMotionRequestStatus === _RequestStatusTypes2.default.FAILED
          })
        ),
        purchaseMotionRequestStatus === _RequestStatusTypes2.default.SUCCEEDED && _react2.default.createElement(_reactRhumb.NavMarker, { name: 'BUNDLE_PAGE' }),
        _react2.default.createElement(_CurrencyPicker2.default, null),
        _react2.default.createElement(
          PageTitle,
          { 'data-selenium-id': 'page-success' },
          _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.pageTitle' })
        ),
        _react2.default.createElement(
          SubTitle,
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.subtitle' })
        ),
        _react2.default.createElement(
          ContentContainer,
          null,
          _react2.default.createElement(
            FlexMain,
            null,
            _react2.default.createElement(
              BundleHubPicker,
              null,
              _react2.default.createElement(
                _SpinnerLoadWrapper2.default,
                {
                  style: { minHeight: '40vh' },
                  isLoading: purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED
                },
                _react2.default.createElement(_MarketingHubBundle2.default, {
                  title: _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.marketing.title' }),
                  subtitle: _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.marketing.subtitle' })
                }),
                _react2.default.createElement(_SalesHubBundle2.default, {
                  title: _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.sales.title' }),
                  subtitle: _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.sales.subtitle' })
                }),
                _react2.default.createElement(_ServiceHubBundle2.default, {
                  title: _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.service.title' }),
                  subtitle: _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.service.subtitle' })
                }),
                _react2.default.createElement(_AddOns2.default, {
                  title: _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.addOns.title' }),
                  subtitle: _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.addOns.subtitle' })
                }),
                _react2.default.createElement(_Services2.default, {
                  title: _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.services.title' }),
                  subtitle: _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.services.subtitle' })
                })
              )
            ),
            _react2.default.createElement(
              StickyContainer,
              null,
              _react2.default.createElement(_ShoppingCart2.default, null),
              _react2.default.createElement(_PhoneSupport2.default, {
                phoneSourceId: 'bundle',
                border: false,
                screen: _Tracking.SCREENS.CREATE_BUNDLE
              })
            )
          )
        )
      ),
      _react2.default.createElement(_FooterMicrocopy2.default, null)
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    country: (0, _CountrySelectors.countrySelector)(state),
    purchaseMotionRequestStatus: state.purchaseMotionRequestStatus
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _DocumentUtils.withDocumentTitle)(BundlePage, 'bundle'));


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/BundlePage.js
// module id = 82
// module chunks = 3 4